<div class="transaction-view-modern">
  <!-- Header -->
  <div class="header-bar">
    <div class="header-content">
      <div class="title-section">
        <button mat-icon-button [routerLink]="'/' + pathUrlList" class="back-button">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div>
          <h1 class="transaction-title">Transacción #{{ item?.id }}</h1>
          <p class="transaction-date">{{ item?.created_at }}</p>
        </div>
      </div>
      <div class="status-badge" [ngClass]="getStatusClass(item?.status)">
        {{ getStatusLabel(item?.status) }}
      </div>
    </div>
  </div>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate" class="progress-bar"></mat-progress-bar>

  <!-- Main Content -->
  <div class="content-wrapper" *ngIf="!isLoading">
    
    <!-- Left Column -->
    <div class="left-column">
      
      <!-- Status Card -->
      <div class="card">
        <div class="card-header">
          <mat-icon class="card-icon">info</mat-icon>
          <h3>Estado de la orden</h3>
        </div>
        <div class="card-content">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cambiar estado</mat-label>
            <mat-select [(ngModel)]="item.status" (selectionChange)="onChangeStatus()">
              <mat-option [value]="0">Pendiente</mat-option>
              <mat-option [value]="1">Pagado</mat-option>
              <mat-option [value]="4">Pagado Confirmado</mat-option>
              <mat-option [value]="5">Envío Pendiente</mat-option>
              <mat-option [value]="6">Entregado</mat-option>
              <mat-option [value]="2">Cancelado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Invoice Card -->
      <div class="card">
        <div class="card-header">
          <mat-icon class="card-icon">receipt</mat-icon>
          <h3>Factura</h3>
        </div>
        <div class="card-content">
          <mat-spinner *ngIf="isUploading" diameter="40"></mat-spinner>
          
          <div *ngIf="!isUploading">
            <a *ngIf="item.invoice_pdf && item.invoice_pdf.length > 0" 
               [href]="item.invoice_pdf" 
               target="_blank" 
               class="invoice-link">
              <mat-icon>picture_as_pdf</mat-icon>
              Ver factura
            </a>
            
            <div class="invoice-actions">
              <input #inputFile type="file" (change)="onUploadFiles($event.target.files)" style="display: none;" />
              <button mat-stroked-button (click)="inputFile.click()" class="action-button">
                <mat-icon>upload</mat-icon>
                Subir factura
              </button>
              
              <button *ngIf="item.invoice_pdf && item.invoice_pdf.length > 0" 
                      mat-flat-button 
                      color="primary" 
                      (click)="onClickSend()"
                      class="action-button">
                <mat-icon>send</mat-icon>
                Enviar factura
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Card -->
      <div class="card">
        <div class="card-header">
          <mat-icon class="card-icon">person</mat-icon>
          <h3>Cliente</h3>
        </div>
        <div class="card-content">
          <div class="info-row" *ngIf="item?.user?.external_code">
            <span class="label">Usuario</span>
            <span class="value">{{ item.user.external_code }}</span>
          </div>
          <div class="info-row">
            <span class="label">Nombre</span>
            <span class="value">{{ item.user.firstname }} {{ item.user.lastname }}</span>
          </div>
          <div class="info-row" *ngIf="item?.user?.document">
            <span class="label">DNI</span>
            <span class="value">{{ item.user.document }}</span>
          </div>
          <div class="info-row">
            <span class="label">Teléfono</span>
            <span class="value">{{ item.user.phone }}</span>
          </div>
          <div class="info-row">
            <span class="label">Email</span>
            <span class="value email">{{ item.user.email }}</span>
          </div>
        </div>
      </div>

      <!-- Payment Card -->
      <div class="card" *ngIf="item.payment_type == 1">
        <div class="card-header">
          <mat-icon class="card-icon">credit_card</mat-icon>
          <h3>Información de pago - MutualCard</h3>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">Titular</span>
            <span class="value">{{ item.data_payment.card_name }}</span>
          </div>
          <div class="info-row">
            <span class="label">Número</span>
            <span class="value">{{ item.data_payment.card_number }}</span>
          </div>
          <div class="info-row">
            <span class="label">Vencimiento</span>
            <span class="value">{{ item.data_payment.card_month }}/{{ item.data_payment.card_year }}</span>
          </div>
          <div class="info-row">
            <span class="label">CVV</span>
            <span class="value">{{ item.data_payment.card_cvv }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.installment">
            <span class="label">Cuotas</span>
            <span class="value">{{ item.data_payment.installment.installment }}</span>
          </div>
        </div>
      </div>

      <!-- FirstData Card -->
      <div class="card" *ngIf="item.data_payment?.bname">
        <div class="card-header">
          <mat-icon class="card-icon">payment</mat-icon>
          <h3>FirstData</h3>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">Nombre</span>
            <span class="value">{{ item.data_payment.bname }}</span>
          </div>
          <div class="info-row">
            <span class="label">Tarjeta</span>
            <span class="value">{{ item.data_payment.cardnumber }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.installment">
            <span class="label">Cuotas</span>
            <span class="value">{{ item.data_payment.installment.installment }}</span>
          </div>
        </div>
      </div>

      <!-- Cash/Transfer Payment Card -->
      <div class="card" *ngIf="item.payment_type == 2">
        <div class="card-header">
          <mat-icon class="card-icon">attach_money</mat-icon>
          <h3>Información de pago - Transferencia/Efectivo</h3>
        </div>
        <div class="card-content">
          <p class="notice">Pago por transferencia bancaria o efectivo. Verificar con el cliente el método utilizado.</p>
        </div>
      </div>

      <!-- MercadoPago Card -->
      <div class="card" *ngIf="item.payment_type == 3 && item.data_payment?.mercadopago_payment">
        <div class="card-header">
          <mat-icon class="card-icon">account_balance_wallet</mat-icon>
          <h3>Información de pago - MercadoPago</h3>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">ID de pago</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.payment_id }}</span>
          </div>
          <div class="info-row">
            <span class="label">Estado</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.status }}</span>
          </div>
          <div class="info-row">
            <span class="label">Detalle</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.status_detail }}</span>
          </div>
          <div class="info-row">
            <span class="label">Método de pago</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.payment_method }}</span>
          </div>
          <div class="info-row">
            <span class="label">Tipo de pago</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.payment_type }}</span>
          </div>
          <div class="info-row">
            <span class="label">Monto</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.transaction_amount | currency }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.mercadopago_payment.date_approved">
            <span class="label">Fecha de aprobación</span>
            <span class="value">{{ item.data_payment.mercadopago_payment.date_approved }}</span>
          </div>
        </div>
      </div>

      <!-- Coupon Card -->
      <div class="card" *ngIf="item.data_payment?.coupon">
        <div class="card-header">
          <mat-icon class="card-icon">local_offer</mat-icon>
          <h3>Cupón aplicado</h3>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">ID</span>
            <span class="value">#{{ item.data_payment.coupon.id }}</span>
          </div>
          <div class="info-row">
            <span class="label">Código</span>
            <span class="value">{{ item.data_payment.coupon.code }}</span>
          </div>
          <div class="info-row">
            <span class="label">Descuento</span>
            <span class="value">{{ item.data_payment.coupon.amount | currency }}</span>
          </div>
        </div>
      </div>

      <!-- Delivery Card -->
      <div class="card" *ngIf="item.data_payment?.delivery">
        <div class="card-header">
          <mat-icon class="card-icon">local_shipping</mat-icon>
          <h3>Información de envío</h3>
        </div>
        <div class="card-content">
          <div class="delivery-type" *ngIf="item.data_payment.delivery.delivery_type == 2">
            <mat-icon>verified</mat-icon>
            <strong>Envío por OCA</strong>
          </div>
          <div class="delivery-type" *ngIf="item.data_payment.delivery.type == 1 && item.data_payment.delivery.id">
            <mat-icon>store</mat-icon>
            <strong>Envío interno - {{ item.data_payment.delivery.title }}</strong>
          </div>
          
          <div class="info-row">
            <span class="label">Nombre</span>
            <span class="value">{{ item.data_payment.delivery.name }}</span>
          </div>
          <div class="info-row">
            <span class="label">Dirección</span>
            <span class="value">{{ item.data_payment.delivery.street || item.data_payment.delivery.address }} Nº {{ item.data_payment.delivery.number }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.delivery.floor">
            <span class="label">Piso</span>
            <span class="value">{{ item.data_payment.delivery.floor }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.delivery.zip_code">
            <span class="label">Código Postal</span>
            <span class="value">{{ item.data_payment.delivery.zip_code }}</span>
          </div>
          <div class="info-row">
            <span class="label">Teléfono</span>
            <span class="value">{{ item.data_payment.delivery.phone }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.delivery.shipping_cost">
            <span class="label">Costo de envío</span>
            <span class="value">{{ item.data_payment.delivery.shipping_cost | currency }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.delivery.price && !item.data_payment.delivery.shipping_cost">
            <span class="label">Costo de envío</span>
            <span class="value">{{ item.data_payment.delivery.price | currency }}</span>
          </div>
          <div class="info-row" *ngIf="item.data_payment.delivery.delivery_days">
            <span class="label">Días de entrega</span>
            <span class="value">{{ item.data_payment.delivery.delivery_days }} días</span>
          </div>
        </div>
      </div>

      <!-- Office Pickup Card -->
      <div class="card" *ngIf="item.data_payment?.office">
        <div class="card-header">
          <mat-icon class="card-icon">store</mat-icon>
          <h3>Retira en sucursal</h3>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">Sucursal</span>
            <span class="value">{{ item.data_payment.office.title }}</span>
          </div>
          <div class="info-row">
            <span class="label">Dirección</span>
            <span class="value">{{ item.data_payment.office.address }}</span>
          </div>
        </div>
      </div>

      <!-- Other Delivery Card -->
      <div class="card" *ngIf="!item.data_payment?.delivery && !item.data_payment?.office">
        <div class="card-header">
          <mat-icon class="card-icon">help_outline</mat-icon>
          <h3>Información de envío</h3>
        </div>
        <div class="card-content">
          <p class="notice">Otras opciones de envío. Comunicarse con la persona para coordinar.</p>
        </div>
      </div>

    </div>

    <!-- Right Column -->
    <div class="right-column">
      
      <!-- Products Card -->
      <div class="card">
        <div class="card-header">
          <mat-icon class="card-icon">shopping_cart</mat-icon>
          <h3>Productos</h3>
        </div>
        <div class="card-content">
          <div class="product-list">
            <div class="product-item" *ngFor="let product of item.items">
              <div class="product-info">
                <span class="product-code">{{ product.product.external_code }}</span>
                <span class="product-title">{{ product.product.title }}</span>
              </div>
              <div class="product-details">
                <span class="quantity">x{{ product.quantity }}</span>
                <span class="price">{{ product.subtotal | currency }}</span>
              </div>
            </div>
          </div>
          
          <mat-divider class="divider"></mat-divider>
          
          <div class="summary">
            <div class="summary-row">
              <span class="label">Subtotal</span>
              <span class="value">{{ item.subtotal | currency }}</span>
            </div>
            <div class="summary-row">
              <span class="label">Adicionales</span>
              <span class="value">{{ getAdditional() | currency }}</span>
            </div>
            <div class="summary-row">
              <span class="label">Envío</span>
              <span class="value">{{ item.delivery | currency }}</span>
            </div>
            <div class="summary-row" *ngIf="item.discount > 0">
              <span class="label">Descuentos</span>
              <span class="value discount">-{{ item.discount | currency }}</span>
            </div>
            <div class="summary-row" *ngIf="item.discount_coupon > 0">
              <span class="label">Descuento cupón</span>
              <span class="value discount">-{{ item.discount_coupon | currency }}</span>
            </div>
            <mat-divider class="divider"></mat-divider>
            <div class="summary-row total">
              <span class="label">Total</span>
              <span class="value">{{ item.total | currency }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<swal #reserveSuccess title="Enviada!" text="Factura enviada correctamente!" type="success"></swal>
